import dataProvider from "src/dataProvider";

let fetcher = dataProvider("adminInstance");

export const submitSiteVisitDetails = async (
  projectId: string,
  payload: any
) => {
  const siteVisitPayload = {
    siteVisitFirstDate: payload.siteVisitFirstDate,
    siteVisitedByEntity: payload.siteVisitedByEntity || [],
    siteVisitConfirmation: payload.siteVisitConfirmation,
    siteVisitConfirmationRemarks: payload.siteVisitConfirmationRemarks,
    siteDeselect: payload.siteDeselect,
    siteDeselectReason: payload.siteDeselectReason,
    fileIds: payload.fileIds || [], // Include fileIds in payload
  };
  return fetcher.put(
    `/projects/land-ownership/${projectId}/site-visit`,
    siteVisitPayload
  );
};

export const submitSiteVisitDoc = async (projectId: string, payload: any) => {
  return fetcher.post(`/projects/${projectId}/document`, payload);
};

export const submitSiteVisitDocs = async (
  projectId: string,
  payload: any[]
) => {
  // Upload documents one by one

  const results = [];
  for (let i = 0; i < payload.length; i++) {
    try {
      const result = await submitSiteVisitDoc(projectId, payload[i]);
      results.push({ success: true, data: result, index: i });
    } catch (error) {
      results.push({ success: false, error, index: i });
      throw error; // Stop on first error
    }
  }

  return results;
};
